<script setup lang="ts">
import { TextFieldProps } from '@/components/forms/types.ts';
import TextField from '../forms/TextField/TextField.vue';
import { useDebounceFn } from '@vueuse/core';
import { mdiMagnify } from '@mdi/js';

export type SearchFieldProps = Omit<TextFieldProps, 'label'> & {
  modelValue?: string;
  debounce?: number; // debounce time in ms
  placeholder?: string;
  label?: string | boolean;
};
const props = withDefaults(defineProps<SearchFieldProps>(), {
  modelValue: undefined,
  debounce: 500,
  placeholder: undefined,
  label: true,
});

const emits = defineEmits<{
  'update:modelValue': [modelValue: string | undefined];
}>();

const update = useDebounceFn((value: string) => {
  if (value !== props.modelValue) emits('update:modelValue', value);
}, props.debounce);
</script>

<template>
  <TextField
    v-bind="{ ...props, ...$attrs }"
    :modelValue="modelValue"
    :label="label === true || label === undefined ? $t('Keyword') : label || undefined"
    :appendInnerIcon="mdiMagnify"
    :placeholder="placeholder"
    clearable
    @update:modelValue="update"
  />
</template>
